import React, { useState } from "react";
import "react-confirm-alert/src/react-confirm-alert.css";
import Comments from "./Comments";

const FormPhone = React.forwardRef(
  (
    {
      name,
      label,
      error,
      onChange,
      commentsFactory,
      identical,
      value,
      className,
      ...rest
    },
    ref
  ) => {
    const [phoneValidationError, setPhoneValidationError] = useState();
    const [showComments, setShowComments] = useState(false);

    const toggleComments = () => {
      setShowComments(!showComments);
    };

    const comments = commentsFactory?.get(name);

    const handleChange = (e) => {
      if (e.currentTarget.value !== "") {
        if (
          value &&
          e.currentTarget.value.length < value.length &&
          (value[value.length - 1] === "-" ||
            value[value.length - 1] === ")" ||
            value[value.length - 1] === "(")
        ) {
          e.currentTarget.value = e.currentTarget.value.slice(0, -1);
        }

        const phoneNumber = formatPhoneNumber(e.currentTarget.value);
        e.currentTarget.value = phoneNumber;
        if (phoneNumber.length === 0 || phoneNumber.length === 14) {
          setPhoneValidationError(undefined);
        } else {
          setPhoneValidationError("Phone number is invalid.");
        }
      } else {
        setPhoneValidationError(undefined);
      }

      onChange(e);
    };

    const formatPhoneNumber = (phoneNumberString) => {
      var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
      let phoneNumber = "";
      if (cleaned[0]) phoneNumber += `(${cleaned[0]}`;
      if (cleaned[1]) phoneNumber += cleaned[1];
      if (cleaned[2]) phoneNumber += `${cleaned[2]})`;
      if (cleaned[3]) phoneNumber += ` ${cleaned[3]}`;
      if (cleaned[4]) phoneNumber += cleaned[4];
      if (cleaned[5]) phoneNumber += `${cleaned[5]}-`;
      if (cleaned[6]) phoneNumber += cleaned[6];
      if (cleaned[7]) phoneNumber += cleaned[7];
      if (cleaned[8]) phoneNumber += cleaned[8];
      if (cleaned[9]) phoneNumber += cleaned[9];
      return phoneNumber;
    };

    return (
      <>
        <div className="mb-3" {...rest}>
          {comments && showComments ? (
            <Comments comments={comments} commentsFactory={commentsFactory} />
          ) : null}
          {identical && (
            <i className="fab fa-searchengin text-danger float-end mb-2 ms-2 d-print-none"></i>
          )}
          {label && (
            <label htmlFor={name} className="form-label">
              {label}
              {comments?.length > 0 ? (
                <i
                  className="fas fa-comment-alt text-warning m-2"
                  onClick={toggleComments}
                />
              ) : null}
            </label>
          )}
          <input
            style={{ width: "150px" }}
            placeholder="(___) ___-____"
            value={value || ""}
            {...rest}
            name={name}
            id={name}
            ref={ref}
            className={`form-control ${
              className ? `${className} border-secondary` : "border-secondary"
            }`}
            onChange={handleChange}
          />
          {error && <div className="alert alert-danger">{error}</div>}
          {phoneValidationError && (
            <div className="alert alert-danger">{phoneValidationError}</div>
          )}
        </div>
      </>
    );
  }
);

export default FormPhone;
